import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/_clearing-core/sweep/')({
  beforeLoad: () => {
    throw redirect({ to: '/sweep/plan', replace: true });
  },
  preload: false,
});
